import React from 'react';

function Header() {
  return (
    <div className="flex justify-center text-3xl font-bold">Suit Store</div>
  );
}

export default Header;
